<template>
	<article class="strategy-showcase py-500-md py-400">
		<p v-if="strategy.eyebrow" class="overline mb-100" :class="{ 'text-color-white': isDarkTheme }">{{
			strategy.eyebrow
		}}</p>
		<div
			class="display-flex justify-content-space-between flex-wrap-wrap"
			:class="{ 'align-items-center': isMultipleStats }"
		>
			<div class="col-12 col-7-lg">
				<h3 class="heading-1" :class="{ 'text-color-white': isDarkTheme }">
					{{ strategy.title }}
				</h3>
				<div class="body-lg mt-50" v-html="strategy.summary"></div>
				<p v-if="strategy.link?.href" class="mt-150 mb-50 body-lg">
					<BaseCtaLink
						:icon="appStore.isMobile ? '' : 'arrow'"
						:is-orange="isDarkTheme"
						:link="strategy.link"
					/>
				</p>
			</div>
			<div class="col-12 col-4-lg text-align-center">
				<div class="display-flex flex-wrap-wrap justify-content-center">
					<p
						v-for="stat in strategy.stats"
						:key="stat.key"
						class="col-6 col-12-lg body-lg m-0 py-100"
						:class="[{ 'pt-0-lg': !isMultipleStats }, { 'text-color-gray-40': isDarkTheme }]"
					>
						<span class="heading-1 display-block mb-50 pb-25" :class="{ 'text-color-white': isDarkTheme }">
							{{ formatStat(stat.key) }}</span
						>
						{{ stat.value }}
					</p>
				</div>
			</div>
		</div>
		<div v-if="strategy.featuredImages" class="display-flex gutters-150 mt-300">
			<figure
				v-for="(image, i) in strategy.featuredImages"
				:key="i"
				class="col-6 col-4-md m-0 position-relative"
				:class="{ 'display-none-smo': i === 2 }"
			>
				<div :style="`background-image: url(${image})`" role="img" class="aspect-ratio-4-3 bg-img"></div>
			</figure>
		</div>
		<div
			v-if="strategy.featuredImagesCaption"
			class="col-12 zeta ff-ivar-text font-style-italic font-weight-lighter mt-100 strategy-showcase__caption"
			v-html="strategy.featuredImagesCaption"
		></div>
	</article>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { number } from '@filters/shared-filters';
import { StrategyShowcaseInfo } from 'types/real-estate-strategy';
import { useAppStore } from '@stores/app';
interface Props {
	strategy: StrategyShowcaseInfo;
	isDarkTheme?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	isDarkTheme: true
});

const appStore = useAppStore();

const isMultipleStats = computed((): boolean => {
	return props.strategy?.stats && props.strategy?.stats.length > 1;
});

function formatStat(stat: string | number): string {
	if (Number(stat)) {
		return number(stat);
	} else {
		return stat as string;
	}
}
</script>

<style lang="scss">
@use '../../styles/constants/colors' as *;

.strategy-showcase {
	&__caption {
		color: gray(20);
		a {
			color: inherit;
			text-decoration: underline;

			&:hover,
			&:focus {
				color: token('brand-primary');
			}
		}
	}
}
</style>
